import axios from "axios";
import store from "@/store";

const http = axios.create({
    baseURL: "/api",
  // 设置区分开发与生产环境url
  //baseURL: process.env.NODE_ENV === "development" ? "/api" : baseURL,
  timeout: 50000,
});

// 添加请求拦截器
http.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  config.headers['Content-Type'] = 'application/json;charset=utf-8';
    config.withCredentials = true; // 允许携带cookie
    return config;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  });
// 所有請求響應後處理關閉Loading
http.interceptors.request.use(
  config => {
    store.commit("updateApiCount", "add");
    return config;
  },
  error => {
    store.commit("updateApiCount", "sub");
    Promise.reject(error);
  }
);
// 添加响应拦截器
http.interceptors.response.use(
  response => {
    store.commit("updateApiCount", "sub");
    var res = response.data;
    // 如果是返回的文件
    if (response.config.responseType === 'blob') {
      if (response.headers['content-disposition'] != null && response.headers['content-disposition'].indexOf("attachment;") != -1) {
        return {success:1, data: res}
      }
      else {
        return {success:2, data: res} //導出文件可能異常，在調用者中處理
      }
    }

    // 兼容服务端返回的字符串数据
    if (typeof res === 'string') {
      res = res ? JSON.parse(res) : res
    }
    return res;
  },
  error => {
    store.commit("updateApiCount", "sub");
    console.log('err' + error) // for debug
    return Promise.reject(error)
  })
export default http;

const httpUpload = axios.create({
    baseURL: "/api",
    // 设置区分开发与生产环境url
    //baseURL: process.env.NODE_ENV === "development" ? "/api" : baseURL,
    timeout: 50000,
});
httpUpload.interceptors.request.use(function (config) {    
    config.withCredentials = true; // 允许携带cookie
    return config;
}, function (error) {
    return Promise.reject(error);
});
httpUpload.interceptors.response.use(
    response => {
        let res = response.data;
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        return res;
    },
    error => {
        console.log('err' + error) // for debug
        return Promise.reject(error)
    });
export { httpUpload };
